import React from "react";
import "./SportOneSubscription.scss";
import { useNavigate } from "react-router-dom";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const headingColors = ["color-1", "color-2", "color-3", "color-4"];

const SportOneSubscription = () => {
  const navigate = useNavigate();
  const { documents: memberships, loading } = useCollection("products", [
    "category",
    "array-contains",
    "Membership",
  ]);

  const handleClick = (productId) => {
    navigate(`/product-details-two/${productId}`);
  };

  const renderCard = (product, index) => {
    const colorClass = headingColors[index % headingColors.length];
    const label = product.subCategory?.[0]?.toUpperCase() || "PASS";

    return (
      <div className="card" key={product.id}>
        <h3 className={`card-heading ${colorClass}`}>
          {product.name || `W18 Pass ${label}`}
        </h3>

        <ul className="card-features">
          {(product.short_description || "").split("\n").map((line, idx) => (
            <li key={idx}>{line}</li>
          ))}
        </ul>

        <p className="price">₹{product.price || "--"}/month</p>
        <button className="card-button" onClick={() => handleClick(product.id)}>
          {label === "PRO" ? "Explore" : "Buy Now"}
        </button>
      </div>
    );
  };

  // Filter only active products (status === 'Active')
  const activeMemberships = memberships?.filter(
    (product) => product.status === "active"
  );

  return (
    <section className="subscription-section sport-one-fade-section">
      <h2 className="section-title">Choose Your Membership</h2>
      <div className="carousel-wrapper">
        <div className="carousel">
          {/* {loading ? <p>Loading...</p> : memberships?.map(renderCard)} */}
          {loading ? (
            <p>Loading...</p>
          ) : activeMemberships?.length > 0 ? (
            activeMemberships.map(renderCard)
          ) : (
            <p>No active memberships available at the moment.</p> // ✅ Optional fallback
          )}
        </div>
      </div>
    </section>
  );
};

export default SportOneSubscription;

// import React from 'react';
// import './SportOneSubscription.scss';
// import { useNavigate } from 'react-router-dom';
// import { useCollection } from '../../../../firebase files/hooks/useCollection';

// const headingColors = ['color-1', 'color-2', 'color-3', 'color-4'];

// const SportOneSubscription = () => {
//   const navigate = useNavigate();
//   const { documents: memberships, loading } = useCollection(
//     'products',
//     ['category', 'array-contains', 'Membership']
//   );

//   const handleClick = (productId) => {
//     navigate(`/product-details-two/${productId}`);
//   };

//   const renderCard = (product, index) => {
//     console.log("Rendering product:", product); // ✅ Debug log
//     const colorClass = headingColors[index % headingColors.length];
//     const label = product.subCategory?.[0]?.toUpperCase() || 'PASS';

//     return (
//       <div className="card" key={product.id}>
//         <h3 className={`card-heading ${colorClass}`}>
//           {product.name || `W18 Pass ${label}`}
//         </h3>

//         <ul className="card-features">
//           {(product.short_description || '').split('\n').map((line, idx) => (
//             <li key={idx}>{line}</li>
//           ))}
//         </ul>

//         <p className="price">₹{product.price || '--'}/month</p>
//         <button className="card-button" onClick={() => handleClick(product.id)}>
//           {label === 'PRO' ? 'Explore' : 'Buy Now'}
//         </button>
//       </div>
//     );
//   };

//   // Filter only active products (status === 'Active')
//   const activeMemberships = memberships?.filter(
//     (product) => product.status === 'active'
//   );

//   console.log("Filtered active memberships:", activeMemberships); // ✅ Debug log

//   return (
//     <section className="subscription-section sport-one-fade-section">
//       <h2 className="section-title">Choose Your Membership</h2>
//       <div className="carousel-wrapper">
//         <div className="carousel">
//           {loading ? (
//             <p>Loading...</p>
//           ) : activeMemberships?.length > 0 ? (
//             activeMemberships.map(renderCard)
//           ) : (
//             <p>No active memberships available at the moment.</p> // ✅ Optional fallback
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SportOneSubscription;
